export const GET_JOB_ID = 'GET_JOB_ID'
export const GET_SAMPLE = 'GET_SAMPLE'
export const GET_STATUS = 'GET_STATUS'
export const GET_PROCESSING_ERRORS = 'GET_PROCESSING_ERRORS'
export const GET_PROCESSING_ERRORS_LENGTH = 'GET_PROCESSING_ERRORS_LENGTH'
export const GET_JOB_LIST = 'GET_JOB_LIST'
export const GET_JOB_ERRORS_BY_PROJECT = 'GET_JOB_ERRORS_BY_PROJECT'
